<template>
<div>
    <mainmenu />
    <form @submit.prevent="handleLoginForm">  
        <p> Weet u zeker dat u wilt afmelden?</p>
        <button @click="cancel">Annuleren</button>
        <button @click="logout">Afmelden</button>
    </form>
</div>
</template>

<script>
export default {
    methods: {
        cancel() {
            this.$router.go(-1)
        },
        logout() {
            // destroy session
            this.$store.dispatch('logout')
        }
    },
    components: {
        'mainmenu': require('@/components/MainMenu.vue').default 
    }
}
</script>
